import { useState } from "react";
import api from "@/lib/api";
import useApiData from "@/hooks/useApiData";
import FilterBar from "@/components/FilterBar";
import ListState from "@/components/ListState";
import { FeaturedArticle, ArticleCard } from "@/components/news/ArticleCards";

const CATEGORIES = [
  { id: "all", label: "All" },
  { id: "news", label: "News" },
  { id: "tournament", label: "Tournaments" },
  { id: "coaching_tips", label: "Coaching Tips" },
  { id: "community", label: "Community" },
];

const News = () => {
  const [activeCategory, setActiveCategory] = useState("all");
  const { data: news, loading } = useApiData(api.getNews, activeCategory === "all" ? {} : { category: activeCategory });
  const featured = news[0]?.featured ? news[0] : null;
  const rest = featured ? news.slice(1) : news;

  return (
    <div className="pt-16" data-testid="news-page" style={{ background: "var(--lrg-bg)" }}>
      <section className="py-16" style={{ background: "var(--lrg-surface)" }} data-testid="news-hero">
        <div className="container-custom">
          <div className="overline mb-4">Journal</div>
          <h1 className="font-display text-4xl sm:text-5xl font-bold tracking-tighter text-[#F2EDE4] mb-3">News</h1>
          <p className="text-[#F2EDE4]/30 max-w-md">Updates, results, and stories from LRG Squash.</p>
        </div>
      </section>

      <FilterBar options={CATEGORIES} active={activeCategory} onChange={setActiveCategory} />

      <section className="section" data-testid="news-grid">
        <div className="container-custom">
          <ListState loading={loading} isEmpty={news.length === 0} loadingText="Loading news..." emptyText="No articles found in this category.">
            {featured && <FeaturedArticle article={featured} />}
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
              {rest.map((article) => <ArticleCard key={article.id} article={article} />)}
            </div>
          </ListState>
        </div>
      </section>

      <section className="section" style={{ background: "var(--lrg-surface)" }} data-testid="news-submit-cta">
        <div className="container-custom text-center">
          <h3 className="font-display text-2xl md:text-3xl font-bold text-[#F2EDE4] mb-4">Have a Story to Share?</h3>
          <p className="text-[#F2EDE4]/40 max-w-xl mx-auto mb-6">
            We welcome community contributions. Submit your tournament results, event announcements, or squash stories for publication.
          </p>
          <a href="/contact" className="btn-primary" data-testid="news-submit-story">Submit Your Story</a>
        </div>
      </section>
    </div>
  );
};

export default News;
